import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { BlogDevelopmentService } from '../blog-development.service';
import { BlogDevelopment } from '../blog-development';
import { BlogDevelopmentComponent } from '../blog-development/blog-development.component';

@Component({
    selector: 'app-blog-development-list',
    templateUrl: './blog-development-list.component.html',
    styleUrls: ['./blog-development-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class BlogDevelopmentListComponent implements OnInit {
	constructor(
		private blogDevelopmentService: BlogDevelopmentService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private constantService: ConstantService,
	) {
		this.statuses = blogDevelopmentService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() blogId: any;
	blogDevelopments: any;
	blogDevelopment: BlogDevelopment;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	locations: any;
	columns: any[] = [
		// { field: 'blogId', header: 'BlogId', width: 'auto' },
		{ field: 'developmentId', header: 'DevelopmentId', width: 'auto' },
		{ field: 'addressDevelopmentName', header: 'Address Development Name', width: 'auto' },
	];

	ngOnInit(): void {
		this.locations = this.constantService.locations;
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	getLocationName(locationId: any) {
		if(locationId) {
			let locationName = this.locations.find(location => location.locationId === locationId)?.name;
			return locationName ? ` - ${locationName}` : '';
		}
		return '';
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-blogDevelopment-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.blogId)
				{
					// show only shortTermRentals that are assigned to this propertyCodeFilter
					let blogIdFilter = { 'blogId': { 'value': JSON.stringify(this.blogId), 'matchMode': 'in' } };
					Object.assign(event.filters, blogIdFilter);
				}

			const pageNumber = Math.round(event.first / event.rows);
			this.blogDevelopmentService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.blogDevelopments = res.data.blogDevelopments;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.blogDevelopments = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(blogDevelopment: BlogDevelopment) {
		try {
			this.formLoading = true;
			this.blogDevelopmentService.update(blogDevelopment)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.blogDevelopments.map((blogDevelopment, i) => {
							if (blogDevelopment.blogDevelopmentId === res.data.blogDevelopment.blogDevelopmentId) {
								this.blogDevelopments[i] = res.data.blogDevelopment;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}


	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add BlogDevelopment'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BlogDevelopmentComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addBlogDevelopmentCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(blogDevelopment: BlogDevelopment) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			blogDevelopment: blogDevelopment,
			title: 'Edit BlogDevelopment'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BlogDevelopmentComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateBlogDevelopmentCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteBlogDevelopmentCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addBlogDevelopmentCB(blogDevelopment: BlogDevelopment) {
		console.log('Adding BlogDevelopment: ' + JSON.stringify(blogDevelopment));
		// if we don't have a blogDevelopments array yet...
		if (!this.blogDevelopments) {
			this.blogDevelopments = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.blogDevelopments.unshift(blogDevelopment);

		// no idea what this is but it is required to update the array
		this.blogDevelopments = [...this.blogDevelopments];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BlogDevelopment ' + blogDevelopment.blogDevelopmentId + ' Added', life: 3000 });
	}

	updateBlogDevelopmentCB(blogDevelopment: BlogDevelopment) {
		console.log('Updating BlogDevelopment: ' + JSON.stringify(blogDevelopment));
		let itemIndex = this.blogDevelopments.findIndex((item: any) => item.blogDevelopmentId === blogDevelopment.blogDevelopmentId);
		this.blogDevelopments[itemIndex] = blogDevelopment;

		// no idea what this is but it is required to update the array
		this.blogDevelopments = [...this.blogDevelopments];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BlogDevelopment ' + blogDevelopment.blogDevelopmentId + ' Updated', life: 3000 });
	}

	deleteBlogDevelopmentCB(blogDevelopment: BlogDevelopment) {
		console.log('Removing BlogDevelopment: ' + blogDevelopment);
		this.blogDevelopments.splice(this.blogDevelopments.indexOf(blogDevelopment), 1);
		this.recordTotal = this.blogDevelopments.length;

		// no idea what this is but it is required to update the array
		this.blogDevelopments = [...this.blogDevelopments];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BlogDevelopment ' + blogDevelopment.blogDevelopmentId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.blogDevelopments ? this.first === (this.blogDevelopments.length - this.rows) : true; }
	isFirstPage(): boolean { return this.blogDevelopments ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(blogDevelopment: any) {
		if (blogDevelopment?.status) {
			const status = this.statuses.find((e: any) => e.value == blogDevelopment.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
